<dx-validation-group #validationGroupComponent style="height: 100%">

  <div [style.flex-direction]="appService.isSmallScreen()? 'column' : 'row'"
       style="padding: 10px 20px 0 20px; display: flex; gap: 15px">
    <div style="flex: 1 1">
      <dx-text-box
        [(isValid)]="isDashboardNameValid"
        [(value)]="newDashboard.name" valueChangeEvent="keyup"
        (onKeyDown)="editMode = true;"
        label="{{'DASHBOARD_FORM.NAME' | translate}}">
        <dx-validator>
          <dxi-validation-rule [max]="gmService.STR_DIM_MID"
                               [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MID)"
                               type="stringLength"></dxi-validation-rule>
          <dxi-validation-rule
            message="{{'DASHBOARD_FORM.NAME_FIELD' | translate}} {{'COMMON.IS_REQUIRED' | translate}}"
            type="required"></dxi-validation-rule>
        </dx-validator>
      </dx-text-box>
    </div>
  </div>
  <!--    <dx-scroll-view>-->
  <div [style.flex-direction]="'column'"
       style="padding: 0 20px 20px; display: flex; gap: 15px; flex: 1 1 0; overflow: hidden">
    <div style="display: flex; flex-direction: column">
      <p>{{ 'DASHBOARD_FORM.AVAILABLE_WIDGETS' | translate }}</p>
      <div style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 10px">
        <ng-container *ngFor="let widget of dashboardService.widgets">
          <dx-button
            (onClick)="addWidgetToList(widget)"
            class="addWidgetButton"
            type="default">
            <div [id]="widget.id"
                 class="widgetListRow">
              <b>{{ "WIDGETS.NAMES." + widget.name | translate }}</b><br/>
              <i class="vr-ic_fluent_add_24_regular"></i>
            </div>
          </dx-button>
        </ng-container>
      </div>
    </div>
    <div style="flex: 1 1 0; display: flex; flex-direction: column; overflow: hidden">

      <!-- Lista widgets aggiunti -->
      <p>{{ 'DASHBOARD_FORM.SELECTED_WIDGETS' | translate }}</p>
      <dx-list
        [(items)]="dashboardWidgets"
        [bounceEnabled]="false"
        [pageLoadMode]="'scrollBottom'"
        [scrollByContent]="false"
        [scrollByThumb]="true"
        [showScrollbar]="'always'"
        class="selectedWidgetsList dx-card flat"
        displayExpr="name"
        itemTemplate="selectedListItem"
        noDataText="{{'COMMON.NO_DATA_FOUND' | translate}}">
        <div *dxTemplate="let dWidget of 'selectedListItem', index as index" style="padding: 0">

          <div
            [id]="index"
            style="display:flex; flex-direction: row; align-items: center; padding: 10px 11px 10px 20px; gap: 20px">
            <b>{{ "WIDGETS.NAMES." + dWidget.widgetType | translate }}</b>
            <dx-text-box
              #widgetForms
              (onValueChanged)="editMode = true"
              valueChangeEvent="keyup"
              style="flex: 1 1; margin-top: 0"
              placeholder="{{'DASHBOARD_FORM.WIDGET_NAME' | translate}}"
              [(value)]="dWidget.name">
              <dx-validator>
                <dxi-validation-rule
                  message="{{'DASHBOARD_FORM.WIDGET_NAME_FIELD' | translate}} {{'COMMON.IS_REQUIRED' | translate}}"
                  type="required"></dxi-validation-rule>
                <dxi-validation-rule
                  [max]="gmService.STR_DIM_MID"
                  [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MID)"
                  type="stringLength"></dxi-validation-rule>
              </dx-validator>

            </dx-text-box>
          </div>

          <!--          <dx-form-->
          <!--            #widgetForms-->
          <!--            (onFieldDataChanged)="editMode = true"-->
          <!--            [formData]="dWidget"-->
          <!--            [labelLocation]="'top'">-->
          <!--            <dxi-item [editorOptions]="customerEditTextOptions" dataField="name">-->
          <!--              <dxo-label text="{{'DASHBOARD_FORM.WIDGET_NAME' | translate}}"></dxo-label>-->
          <!--              <dxi-validation-rule-->
          <!--                message="{{'DASHBOARD_FORM.WIDGET_NAME_FIELD' | translate}} {{'COMMON.IS_REQUIRED' | translate}}"-->
          <!--                type="required"></dxi-validation-rule>-->
          <!--              <dxi-validation-rule [max]="gmService.STR_DIM_MID"-->
          <!--                                   [message]="appService.getMaxCharErrorMessage(gmService.STR_DIM_MID)"-->
          <!--                                   type="stringLength"></dxi-validation-rule>-->
          <!--            </dxi-item>-->
          <!--          </dx-form>-->
        </div>
      </dx-list>
    </div>
  </div>
</dx-validation-group>
